import { render, staticRenderFns } from "./NotalarmView.vue?vue&type=template&id=566ab282&scoped=true"
import script from "./NotalarmView.vue?vue&type=script&lang=js"
export * from "./NotalarmView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "566ab282",
  null
  
)

export default component.exports